import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { injectMetadata, removeMetadata } from "@waytek/Utilities/global/injectMetadata";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    location: string[];
    id: string;
    postData: object;
}

const mapStateToProps = (state: ApplicationState) => {
    const currentPage = getCurrentPage(state);

    return {
        nodeId: currentPage.nodeId,
        homePageUrl: getHomePageUrl(state),
        currentPage,
    };
};

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const SchemaForBlogDetail: React.FC<Props> = ({ location, id, currentPage, postData }) => {
    React.useEffect(() => {
        return () => {
            removeMetadata(id);
        };
    }, []);

    const schemaData = postData;
    injectMetadata(JSON.stringify(schemaData), id);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(SchemaForBlogDetail);
